import { getDeviceType } from '@jfs/utils'
import { RootStore } from '../data/store'
import { generateRandomString, getMaskedMobileNumber } from '../util/utill'

export const BASE_URL = process.env.REACT_APP_BASE_URL ?? ''
export const DOMESTIC_REMITTANCE_BASE_URL = process.env.REACT_APP_MONEY_REMITTANCE_BASE_URL ?? ''

let header = {
  'x-channel-id': 8182,
  'Content-Type': 'application/json',
}

export const getHeader = () => {
  return { ...header, 'x-trace-id': getRandomAlphaNumString(16) ?? '', 'x-userjourney-trace-id': UNIQUE_TRACE_ID } ?? {}
}

export const UNIQUE_TRACE_ID = generateRandomString(20)

export const apiConfig = (token: any) => {
  const { appAccessToken, appIdToken, userAccessToken, userIdentifierToken, CHANNEL_ID, deviceSessionId } = token ?? {}

  return {
    baseUrl: `${BASE_URL}`,
    timeOut: 60000,
    headers: {
      'Content-Type': 'application/json',
      'x-channel-id': CHANNEL_ID,
      'x-trace-id': generateRandomString(20),
      'x-userjourney-trace-id': UNIQUE_TRACE_ID,
      'x-device-info': getDeviceInfo(),
      'x-app-access-token': appAccessToken || '', //not required.
      'x-appid-token': appIdToken || '',
      appIDToken: appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-userid-token': userIdentifierToken || '',
      userIDToken: userIdentifierToken || '',
      'x-user-identifier-tokens': RootStore.moneyTransferSession.userIdToken || userIdentifierToken,
      deviceSessionId: deviceSessionId || '',
    },
    retryCount: 0,
  }
}

export const sitConfig = (tokens: any) => {
  const { appAccessToken, appIdToken, userAccessToken, userIdToken, CHANNEL_ID, deviceSessionId } = tokens
  return {
    baseUrl: `${BASE_URL}`,
    timeOut: 60000,
    headers: {
      'content-type': 'application/json',
      'x-channel-id': CHANNEL_ID,
      'x-trace-id': generateRandomString(20),
      'x-userjourney-trace-id': UNIQUE_TRACE_ID,
      'x-device-info': getDeviceInfo(),
      //'x-api-key': '17asdf1231232sdf1232',
      'x-app-access-token': appAccessToken || '',
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-userid-token': userIdToken || '',
      'x-user-identifier-tokens': RootStore.moneyTransferSession.userIdToken || userIdToken,
      deviceSessionId: deviceSessionId || '',
    },
    retryCount: 0,
  }
}

export const usrSessionRefreshConfig = (appAccToken: string, appIdToken: string, CHANNEL_ID: string) => {
  return {
    baseUrl: `${BASE_URL}`,
    headers: {
      'content-type': 'application/json',
      'x-channel-id': CHANNEL_ID,
      'x-trace-id': generateRandomString(20),
      'x-userjourney-trace-id': UNIQUE_TRACE_ID,
      'x-app-access-token': appAccToken || '',
      'x-appid-token': appIdToken || '',
    },
    retryCount: 0,
  }
}

export const appSessionRefreshConfig = (CHANNEL_ID: string) => {
  return {
    baseUrl: `${BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Channel-ID': CHANNEL_ID,
      'X-Trace-ID': generateRandomString(20),
      'x-userjourney-trace-id': UNIQUE_TRACE_ID,
    },
    retryCount: 0,
  }
}

export const setHeader = (newHeader: any) => {
  header = newHeader
}

export function getDeviceInfo() {
  return JSON.stringify({
    ipAddress: '10.11.11',
    type: getDeviceType(),
    os: 'ANDROID',
    appVersion: RootStore?.agent?.deviceInfo?.appVersion,
    appName: RootStore?.agent?.deviceInfo?.appName,
    appId: RootStore?.agent?.deviceInfo?.appId,
    capability: null,
    sdkVersion: RootStore?.agent?.deviceInfo?.osVer,
    mobile: getMaskedMobileNumber(RootStore?.agent?.agentInfo?.agentMobileNumber),
    location: {
      latitude: RootStore?.agent?.deviceInfo?.latitude,
      longitude: RootStore?.agent?.deviceInfo?.longitude,
      name: null,
    },
    userAgent: navigator.userAgent,
  })
}
